<template>
  <transition>
    <div
      v-if="alertValue.show"
      class="alertMain"
      :class="[
        alertValue.show ? 'show' : 'hide',
        alertValue.type === 'success' ? 'successBg' : 'errorBg'
      ]"
    >
      <span
        v-if="alertValue.type !== 'success'"
        class="fas fa-exclamation-circle errorText"
      ></span>
      <span v-else class="fas fa-check-circle successText"></span>
      <span
        class="msg"
        :class="alertValue.type === 'success' ? 'successText' : 'errorText'"
        >{{ alertValue.type !== "success" ? "Error:" : "" }}
        {{ alertValue.msg }}</span
      >
      <div
        class="close-btn"
        @click="dismiss"
        :class="alertValue.type === 'success' ? 'successBgBtn' : 'errorBgBtn'"
      >
        <span
          :class="alertValue.type === 'success' ? 'successText' : 'errorText'"
          class="fas fa-times"
        ></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Alert",
  data() {
    return {};
  },
  methods: {
    dismiss() {
      this.$store.commit("global/SET_ALERT", {
        msg: "",
        show: false,
        type: ""
      });
    }
  },
  watch: {
    alertValue() {
      if (this.alertValue.show) {
        setTimeout(() => {
          this.$store.commit("global/SET_ALERT", {
            msg: "",
            show: false,
            type: ""
          });
        }, 6500);
      }
    }
  },
  computed: {
    alertValue() {
      return this.$store.getters["global/alert"];
    }
  }
};
</script>

<style>
.errorBg {
  border-left: 8px solid #ff465a;
  background: #fde2e2;
}
.errorText {
  color: #ff465a;
}
.errorBgBtn {
  background: #ff98a9;
}
.errorBgBtn:hover {
  background: #ff98a9;
}

.successBg {
  border-left: 8px solid #2bc874;
  /* background: #c6f3d4; */
  background: #fff;
}
.successText {
  color: #2bc874;
}
.successBgBtn {
  background: #95eab7;
}
.successBgBtn:hover {
  background: #95eab7;
}
.alertMain {
  padding: 20px 40px;
  min-width: 420px;
  position: fixed;
  right: 5%;
  top: 13%;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  /* z-index: 10; */
  z-index: 9999; 
}

.alertMain.show {
  animation: show_slide 1s ease forwards;
}
@keyframes show_slide {
  0% {
    transform: translateX(100%);
  }
  40% {
    transform: translateX(-10%);
  }
  80% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-10px);
  }
}
.alertMain.hide {
  animation: hide_slide 1s ease forwards;
}
@keyframes hide_slide {
  0% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(0%);
  }
  80% {
    transform: translateX(-10%);
  }
  100% {
    transform: translateX(100%);
  }
}
.alertMain .fa-exclamation-circle {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.alertMain .fas {
  font-size: 22px;
}
.alertMain .msg {
  padding: 0 20px;
  font-size: 18px;
  width: 80%;
}
.alertMain .close-btn {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  padding: 20px 18px;
  cursor: pointer;
}
.alertMain .close-btn .fas {
  font-size: 22px;
  line-height: 40px;
}
</style>
